import { RendernetErrors } from 'core/constants/enums/RendernetErrors.ts';
import { ToastType } from 'core/constants/enums/ToastTypeEnum.ts';
import { sendToast } from 'core/layouts/components/toast/ToastUtils';
import { getErrorImgForAspectRatio } from 'core/utils/utils';
import {
	getUserProfileAsync,
	musicVideoCreateSceneModalSelector,
	setBalance,
	toggleMusicVideoCreateSceneModal,
} from '../appReducer/AppSlice';
import {
	modelsSelector,
	setStudioFeed,
	setStudioFeedCurrentPage,
	setStudioPromptInput,
	setStudioSelectedModels,
	setStudioSelectedStyles,
	setStudioSettings,
	studioFeedBatchWiseMapSelector,
	studioFeedChronologicalBatchIdListSelector,
	studioFeedCurrentPageSelector,
	studioFeedTotalPagesSelector,
	studioPromptInputSelector,
} from './StudioSlice';

export const handleSetStudioSelectedModel = (model) => (dispatch, getState) => {
	const models = modelsSelector(getState());

	dispatch(setStudioSelectedModels({ model }));
	dispatch(
		setStudioSettings({
			settings: models[model],
			setControlNet: false,
			setFacelock: false,
		}),
	);
};

export const handleSetStudioSelectedStyle =
	({ styles, style, replace }) =>
	(dispatch) => {
		dispatch(setStudioSelectedStyles({ styles, style, replace }));
	};

export const handleSetStudioSelectedLora = (lora) => (dispatch, getState) => {
	const promptInput = studioPromptInputSelector(getState());
	const newPromptInput = `${promptInput} ${lora.trigger}`;
	dispatch(setStudioPromptInput(newPromptInput));
};

export const fetchStudioFeedNewPage = () => async (dispatch, getState) => {
	const currentPage = studioFeedCurrentPageSelector(getState());
	const totalPages = studioFeedTotalPagesSelector(getState());

	if (currentPage < totalPages) {
		dispatch(setStudioFeedCurrentPage(currentPage + 1));
	}
};

export const handelStudioImagesErrorFromSocket = (generationDetails) => (dispatch, getState) => {
	const studioFeedBatchWiseMap = studioFeedBatchWiseMapSelector(getState());
	const studioFeedBatchWiseMapCopy = { ...studioFeedBatchWiseMap };

	const batchIdList = Object.keys(studioFeedBatchWiseMap);
	const studioFeedChronologicalBatchIdList = studioFeedChronologicalBatchIdListSelector(getState());

	const { images, generation_id: group, credits } = generationDetails;
	const batchId = `${group}`;

	if (batchIdList.includes(batchId)) {
		const { derivedMedia } = studioFeedBatchWiseMapCopy[batchId];
		const batchDerivedMedia = { ...derivedMedia };

		Object.keys(images).map((mediaId) => {
			const { aspectRatio } = batchDerivedMedia[mediaId];

			batchDerivedMedia[mediaId] = {
				...batchDerivedMedia[mediaId],
				loading: false,
				status: 'failed',

				media: getErrorImgForAspectRatio(aspectRatio),
				thumbnail: getErrorImgForAspectRatio(aspectRatio),
			};

			return null;
		});

		studioFeedBatchWiseMapCopy[batchId] = {
			...studioFeedBatchWiseMapCopy[batchId],
			derivedMedia: batchDerivedMedia,
		};
		dispatch(setBalance(credits));
		dispatch(
			setStudioFeed({
				batchIdList: studioFeedChronologicalBatchIdList,
				batchMap: studioFeedBatchWiseMapCopy,
			}),
		);
	}
};

export const handelStudioMediaErrorFromSocket = (generationDetails) => (dispatch, getState) => {
	const studioFeedBatchWiseMap = studioFeedBatchWiseMapSelector(getState());
	const studioFeedBatchWiseMapCopy = { ...studioFeedBatchWiseMap };
	const musicVideoScenesModalData = musicVideoCreateSceneModalSelector(getState());

	const batchIdList = Object.keys(studioFeedBatchWiseMap);
	const studioFeedChronologicalBatchIdList = studioFeedChronologicalBatchIdListSelector(getState());

	const { media, generation_id: group, credits, error_code: errorCode } = generationDetails;

	const [firstMediaId] = Object.keys(media);
	if (firstMediaId === musicVideoScenesModalData.mediaId) {
		dispatch(toggleMusicVideoCreateSceneModal({ open: false, mediaId: '' }));
	}

	if (errorCode === RendernetErrors.CONTENT_MODERATION) {
		sendToast(ToastType.GEN_FAILED_DUE_TO_CONTENT_MODERATION);
	}
	if (errorCode === RendernetErrors.VIDEO_ANYONE_FAL_GENERATIONS) {
		sendToast(ToastType.VIDEO_GENERATION_FAILED);
	}
	if (errorCode === RendernetErrors.BLOCK_USER_DUE_TO_CONTENT_MODERATION) {
		dispatch(getUserProfileAsync());
	}
	const batchId = `${group}`;

	if (batchIdList.includes(batchId)) {
		const { derivedMedia } = studioFeedBatchWiseMapCopy[batchId];
		const batchDerivedMedia = { ...derivedMedia };

		Object.keys(media).map((mediaId) => {
			const { aspectRatio } = batchDerivedMedia[mediaId];

			batchDerivedMedia[mediaId] = {
				...batchDerivedMedia[mediaId],
				loading: false,
				status: 'failed',

				media: media[mediaId].link ? media[mediaId].link : getErrorImgForAspectRatio(aspectRatio),
				thumbnail: media[mediaId].link
					? media[mediaId].link
					: getErrorImgForAspectRatio(aspectRatio),
			};

			return null;
		});

		studioFeedBatchWiseMapCopy[batchId] = {
			...studioFeedBatchWiseMapCopy[batchId],
			derivedMedia: batchDerivedMedia,
		};
		dispatch(setBalance(credits));
		dispatch(
			setStudioFeed({
				batchIdList: studioFeedChronologicalBatchIdList,
				batchMap: studioFeedBatchWiseMapCopy,
			}),
		);
	}
};

export const loadStudioFeedImageFromSocket = (generationDetails) => (dispatch, getState) => {
	const studioFeedBatchWiseMap = studioFeedBatchWiseMapSelector(getState());
	const studioFeedBatchWiseMapCopy = { ...studioFeedBatchWiseMap };

	const batchIdList = Object.keys(studioFeedBatchWiseMap);
	const studioFeedChronologicalBatchIdList = studioFeedChronologicalBatchIdListSelector(getState());

	const {
		success: generationSuccess,
		generation_id: group,
		images: generatedImages,
		credits,
	} = generationDetails;
	const batchId = `${group}`;

	if (batchIdList.includes(batchId)) {
		const { derivedMedia } = studioFeedBatchWiseMapCopy[batchId];
		const batchDerivedMedia = { ...derivedMedia };

		if (generationSuccess) {
			Object.keys(generatedImages).map((mediaId) => {
				batchDerivedMedia[mediaId] = {
					...batchDerivedMedia[mediaId],
					loading: false,
					status: 'success',
					isNsfw: generatedImages[mediaId].is_nsfw,

					media: generatedImages[mediaId].image,
					thumbnail: generatedImages[mediaId].thumbnail,
					seed: batchDerivedMedia[mediaId].seed,
				};

				return null;
			});

			studioFeedBatchWiseMapCopy[batchId] = {
				...studioFeedBatchWiseMapCopy[batchId],
				derivedMedia: batchDerivedMedia,
			};

			dispatch(
				setStudioFeed({
					batchIdList: studioFeedChronologicalBatchIdList,
					batchMap: studioFeedBatchWiseMapCopy,
				}),
			);
		} else {
			dispatch(handelStudioImagesErrorFromSocket(generationDetails));
		}
		dispatch(setBalance(credits));
	}
};

export const loadStudioFeedMediaFromSocket = (generationDetails) => (dispatch, getState) => {
	const studioFeedBatchWiseMap = studioFeedBatchWiseMapSelector(getState());
	const studioFeedBatchWiseMapCopy = { ...studioFeedBatchWiseMap };

	const batchIdList = Object.keys(studioFeedBatchWiseMap);
	const studioFeedChronologicalBatchIdList = studioFeedChronologicalBatchIdListSelector(getState());

	const {
		success: generationSuccess,
		generation_id: group,
		media: generatedMedia,
		credits,
	} = generationDetails;
	const batchId = `${group}`;

	if (batchIdList.includes(batchId)) {
		const { derivedMedia } = studioFeedBatchWiseMapCopy[batchId];
		const batchDerivedMedia = { ...derivedMedia };

		if (generationSuccess) {
			Object.keys(generatedMedia).map((mediaId) => {
				batchDerivedMedia[mediaId] = {
					...batchDerivedMedia[mediaId],
					loading: false,
					status: 'success',
					isNsfw: generatedMedia[mediaId].is_nsfw,

					media: generatedMedia[mediaId].link,
					thumbnail: generatedMedia[mediaId].thumbnail,
					seed: batchDerivedMedia[mediaId].seed,
					attributes: {
						...(batchDerivedMedia[mediaId]?.attributes ?? {}),
						lipSync: batchDerivedMedia[mediaId]?.attributes.lipSync && {
							...batchDerivedMedia[mediaId]?.attributes.lipSync,
							metadata: generatedMedia[mediaId].metadata,
						},
						videoAnyone: batchDerivedMedia[mediaId]?.attributes.videoAnyone && {
							...batchDerivedMedia[mediaId]?.attributes.videoAnyone,
							metadata: generatedMedia[mediaId].metadata,
						},
						textToVideo: batchDerivedMedia[mediaId]?.attributes.textToVideo && {
							...batchDerivedMedia[mediaId]?.attributes.textToVideo,
							metadata: generatedMedia[mediaId].metadata,
						},
					},
				};

				return null;
			});

			studioFeedBatchWiseMapCopy[batchId] = {
				...studioFeedBatchWiseMapCopy[batchId],
				derivedMedia: batchDerivedMedia,
			};

			dispatch(
				setStudioFeed({
					batchIdList: studioFeedChronologicalBatchIdList,
					batchMap: studioFeedBatchWiseMapCopy,
				}),
			);
		} else {
			dispatch(handelStudioMediaErrorFromSocket(generationDetails));
		}
		dispatch(setBalance(credits));
	}
};
